var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import React from 'react';
import { connect } from 'react-redux';
import { CSSTransition, TransitionGroup, } from 'react-transition-group';
import * as padLeft from 'pad-left';
import FaUserPlus from 'react-icons/lib/fa/user-plus';
var selfStyles = require('./styles.scss');
var ScrollerAthleteScoreRoute = (function (_super) {
    __extends(ScrollerAthleteScoreRoute, _super);
    function ScrollerAthleteScoreRoute(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            athleteScoreRoutes: [],
        };
        _this.pushAthleteScoreRoute = _this.pushAthleteScoreRoute.bind(_this);
        return _this;
    }
    ScrollerAthleteScoreRoute.prototype.componentDidMount = function () {
        var _this = this;
        feathersClient.service('athleteScoreRoutes').on('patched', this.pushAthleteScoreRoute);
        this.timer = window.setInterval(function () {
            var timeNow = Date.now();
            _this.setState({ athleteScoreRoutes: _this.state.athleteScoreRoutes.filter(function (aSR) { return aSR.addedAt + 6000 > timeNow; }) });
        }, 1000);
    };
    ScrollerAthleteScoreRoute.prototype.componentWillUnmount = function () {
        feathersClient.service('athleteScoreRoutes').off('patched', this.pushAthleteScoreRoute);
        clearInterval(this.timer);
    };
    ScrollerAthleteScoreRoute.prototype.pushAthleteScoreRoute = function (athleteScoreRoute) {
        var _this = this;
        if (!athleteScoreRoute) {
            return;
        }
        var athleteScoreRoutes = Array.isArray(athleteScoreRoute)
            ? athleteScoreRoute
            : [athleteScoreRoute];
        var timeNow = Date.now();
        var filteredASR = athleteScoreRoutes.reduce(function (accumulator, aSR) {
            var round = _this.props.workspaceEvent.rounds.find(function (r) { return r.id === aSR.roundId; });
            if (!round || (!_this.props.isPlatform && !round.isScoresVisible)) {
                return accumulator;
            }
            aSR.calculated = typeof aSR.calculated === 'string'
                ? JSON.parse(aSR.calculated)
                : aSR.calculated;
            aSR.addedAt = timeNow;
            aSR.round = round;
            accumulator.push(aSR);
            return accumulator;
        }, []);
        this.setState({
            athleteScoreRoutes: this.state.athleteScoreRoutes.concat(filteredASR),
        });
    };
    ScrollerAthleteScoreRoute.prototype.render = function () {
        return (React.createElement("div", { className: selfStyles.scroller, style: __assign({}, this.props.style) },
            React.createElement(TransitionGroup, { className: 'transition gp' }, this.state.athleteScoreRoutes.map(function (aSR) { return (React.createElement(CSSTransition, { key: "" + aSR.id + aSR.updatedAt, timeout: 375, classNames: {
                    enter: selfStyles.scrollerItemEnter,
                    enterActive: selfStyles.scrollerItemEnterActive,
                    exit: selfStyles.scrollerItemExit,
                    exitActive: selfStyles.scrollerItemExitActive,
                } },
                React.createElement("div", { className: selfStyles.scrollerItem },
                    React.createElement("div", { className: selfStyles.scrollerCard },
                        React.createElement("div", null,
                            React.createElement(FaUserPlus, null),
                            aSR.round && aSR.round.code,
                            padLeft(aSR.bibNumber, 3, '0')),
                        React.createElement("div", null,
                            aSR.round && aSR.round.code,
                            aSR.index + 1,
                            ": ",
                            aSR.calculated.display))))); }))));
    };
    return ScrollerAthleteScoreRoute;
}(React.Component));
var mapStateToProps = function (state) { return ({
    workspaceEvent: {
        rounds: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data,
    },
}); };
export default connect(mapStateToProps)(ScrollerAthleteScoreRoute);



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/ScrollerAthleteScoreRoute/index.tsx
// module id = 740
// module chunks = 0